import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Drives the item detail modal through the `item` search param.
 *
 * `openItem`/`closeItem` set/delete the param (and the local id eagerly so
 * the modal opens without waiting for the router), while the effect syncs
 * the id back from the URL after a 100ms tick — same pattern previously
 * duplicated across the delivery and indoor menu views (back/forward
 * navigation closes/opens the modal).
 */
export function useItemModalParam() {
  const [itemOfferId, setItemOfferId] = useState<string>("");
  const [searchParams, setSearchParams] = useSearchParams();

  const openItem = (itemId: string) => {
    setItemOfferId(itemId);
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("item", itemId);
      return newParams;
    });
  };

  const closeItem = () => {
    setItemOfferId("");
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.delete("item");
      return newParams;
    });
  };

  useEffect(() => {
    const id = setTimeout(() => {
      setItemOfferId(searchParams.get("item") ?? "");
    }, 100);
    return () => clearTimeout(id);
  }, [searchParams]);

  return { itemOfferId, openItem, closeItem };
}
